export default "__VITE_ASSET__581f13b2__"